// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact *all page load* performance metrics in Jira
// * is expected to be short term

export const featureFlagsAddedToEVERYPageLoadEvent = [] as const;
